import { Button } from "@/components/Button"
import { Expense3DSPassword } from "@/components/Cards/Create/Expense/3DSPassword"
import { ExpenseDeliveryAddress } from "@/components/Cards/Create/Expense/DeliveryAddress"
import { ExpensePinCode } from "@/components/Cards/Create/Expense/PinCode"
import { CardsCreateHeader } from "@/components/Cards/Create/Header"
import { Checkbox } from "@/components/Form/Checkbox"
import { Input } from "@/components/Form/Input"
import { FormSelect } from "@/components/Selector"
import { isPinVisibleProvider } from "@/constants/ProviderConstants"
import { ClientType, selectUser, useCardCreate, useStoreClient } from "@usher/pe-client-front-end-lib"
import { CorporateUser } from "@usher/pe-client-front-end-lib/dist/ExClient"
import { clsx } from "clsx"
import { Fragment, useEffect, useState } from "react"
import { FormProvider } from "react-hook-form"
import { FormattedMessage, useIntl } from "react-intl"
import { useHistory } from "react-router-dom"
import { CardDetails } from "./card-details"

export const CardCreateExpense = () => {
  const { $t: t } = useIntl()
  const history = useHistory()
  const { client_type, corp_id } = useStoreClient(selectUser)
  const [check1, setCheck1] = useState(false)
  const isCorporateAccount = client_type === ClientType.Coroporate
  const isCorpUser = corp_id != null
  const [check2, setCheck2] = useState(false)
  const [check3, setCheck3] = useState(false)
  const [check4, setCheck4] = useState(false)
  const [check5, setCheck5] = useState(false)
  const [check6, setCheck6] = useState(false)
  const [check7, setCheck7] = useState(false)
  // const [showModal, setShowModal] = useState(false)
  const onSuccess = (state: unknown) => {
    const bin = formMethods.getValues().card_bin
    const providerId = (bin as unknown as { meta: { provider_id: string } })?.meta.provider_id
    if (providerId === "4") {
      if (typeof state === "object") {
        state = { ...state, provider_id: "4" }
      } else {
        state = { provider_id: "4" }
      }
    }
    // @ts-ignore
    history.push(`/cards/create/select-payment?bin=${bin?.value}`, state)
  }
  const { corporateUsers, isExactProvider, onSubmit, formMethods, allowPhoneAndPin, isVirtual, isVertex } = useCardCreate({
    onSuccess,
  })
  const selectedBin = formMethods.watch("card_bin")
  const providerId = (selectedBin as unknown as { meta: { provider_id: string } })?.meta.provider_id
  const cardType = formMethods.watch("type")
  const isPhysicalCard = cardType === "2"
  const isCorporateOrCorpUser = isCorporateAccount || isCorpUser
  const shouldShowExactProviderConsents = isExactProvider && !isCorporateOrCorpUser
  const shouldShowAuthorizedUserAgreement = isExactProvider && isCorporateOrCorpUser
  const shouldShowDefaultConsents = !isExactProvider
  const shouldShowResidencyConsent = shouldShowDefaultConsents || shouldShowAuthorizedUserAgreement
  const hasMissingExactProviderConsent = !check4 || !check5 || !check6 || !check7
  const hasMissingDefaultConsent = !check2 || !check3
  const hasMissingAuthorizedUserConsent = !check1 || !check3
  const isSubmitDisabled = shouldShowAuthorizedUserAgreement
    ? hasMissingAuthorizedUserConsent
    : shouldShowExactProviderConsents
      ? hasMissingExactProviderConsent
      : hasMissingDefaultConsent

  useEffect(() => {
    setCheck1(false)
    setCheck2(false)
    setCheck3(false)
    setCheck4(false)
    setCheck5(false)
    setCheck6(false)
    setCheck7(false)
  }, [selectedBin])

  return (
    <div>
      {/*<Modal
        onClose={() => history.push("/cards")}
        show={showModal}
        title={
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 rounded-full bg-green-600 text-white flex items-center justify-center">
              <Check size={18} />
            </div>
            <span>Card created</span>
          </div>
        }
      >
        <div className="text-black text-[16px] max-w-[500px] mt-3">Your card has been successfully issued and is now ready to use.</div>
        <div className="flex justify-end mt-4">
          <Button onClick={() => history.push("/cards")}>Close</Button>
        </div>
      </Modal>*/}
      <CardsCreateHeader subtitle={t({ id: "expenses" })} description={t({ id: "mastercard" })} />
      <FormProvider {...formMethods}>
        <form onSubmit={formMethods.handleSubmit(onSubmit)} className="container max-w-[500px] !px-0" noValidate autoComplete="off">
          <CardDetails formMethods={formMethods} />
          <div className="mb-[33px] mt-6 [&_.selector-custom]:font-[ChakraPetchRegular]">
            {isCorporateAccount && isExactProvider ? (
              <Fragment>
                <FormSelect
                  variant="outlined"
                  control={formMethods.control}
                  label={t({ id: "username" })}
                  // @ts-ignore
                  name="user"
                  required
                  options={corporateUsers.map((user) => ({
                    label: `${user.email} (ID ${user.id})`,
                    value: user.id,
                    meta: user,
                  }))}
                  // @ts-ignore
                  onChange={(option) => {
                    const meta = option.meta as CorporateUser | undefined
                    formMethods.setValue("username", meta != null ? `${meta?.first_name} ${meta?.last_name}` : "")
                  }}
                  fullWidth
                />
                <Input.Form
                  type={isPhysicalCard ? "hidden" : "text"}
                  control={formMethods.control}
                  name="username"
                  placeholder={t({ id: "username" })}
                  required={!isPhysicalCard}
                  disabled
                  className="mt-2.5"
                />
              </Fragment>
            ) : (
              <Fragment>
                <Input.Form control={formMethods.control} name="username" required placeholder={t({ id: "username" })} className="mb-2.5" />
              </Fragment>
            )}

            {!isPhysicalCard && <Input.Form control={formMethods.control} name="nickname" placeholder={t({ id: "nickname" })} className="mt-2.5" />}
          </div>
          {isPhysicalCard && cardType != null && (
            <Fragment>
              <div>
                {!isPinVisibleProvider(providerId) && <ExpensePinCode control={formMethods.control} isVertex={isVertex} />}
                <ExpenseDeliveryAddress isRain={isExactProvider && isCorporateAccount} control={formMethods.control} />
              </div>
            </Fragment>
          )}
          {isVirtual && allowPhoneAndPin && <Expense3DSPassword control={formMethods.control} isVertex={isVertex} />}
          {shouldShowExactProviderConsents && (
            <div>
              <Checkbox
                checked={check4}
                onChange={(e) => setCheck4(e.target.checked)}
                label={
                  <span>
                    {" "}
                    I accept the{" "}
                    <a className="text-main-main" href="/legal/e-sign-consent">
                      E-Sign Consent
                    </a>
                  </span>
                }
                className="mt-10"
              />
              <Checkbox
                checked={check5}
                onChange={(e) => setCheck5(e.target.checked)}
                label={
                  <span>
                    I accept the{" "}
                    <a className="text-main-main" href="/legal/card-terms">
                      International Consumer Card Terms
                    </a>
                    , and the{" "}
                    <a className="text-main-main" href="https://www.third-national.com/privacypolicy">
                      Issuer Privacy Policy
                    </a>
                  </span>
                }
                className="my-3"
              />
              <Checkbox
                checked={check6}
                onChange={(e) => setCheck6(e.target.checked)}
                label={
                  <span>
                    I certify that the information I have provided is accurate and that I will abide by all the rules and requirements related to my
                    Tranzbase Spend Card.
                  </span>
                }
              />
              <Checkbox
                checked={check7}
                onChange={(e) => setCheck7(e.target.checked)}
                label={<span>I acknowledge that applying for the Tranzbase Spend Card does not constitute unauthorized solicitation.</span>}
                className="my-3"
              />
            </div>
          )}
          {shouldShowDefaultConsents && (
            <Checkbox
              checked={check2}
              onChange={(e) => setCheck2(e.target.checked)}
              label={
                <span>
                  <FormattedMessage
                    id="term2"
                    values={{
                      b: (chunk) => (
                        <a
                          className="text-main-main"
                          target="_blank"
                          href={process.env.REACT_APP_PATH_HOME + "legal/terms-of-use-for-cards"}
                          rel="noreferrer"
                        >
                          {chunk}
                        </a>
                      ),
                    }}
                  />
                </span>
              }
              className={clsx(!isExactProvider && "mt-10")}
            />
          )}
          {shouldShowAuthorizedUserAgreement && (
            <Checkbox
              checked={check1}
              onChange={(e) => setCheck1(e.target.checked)}
              required
              className="mt-4"
              label={
                <p>
                  I accept the{" "}
                  <a href="/legal/authorized-user-agreement" target="_blank" className="text-main-main">
                    Authorized User Agreement
                  </a>
                </p>
              }
            />
          )}
          {shouldShowResidencyConsent && (
            <Checkbox checked={check3} onChange={(e) => setCheck3(e.target.checked)} label={t({ id: "term3" })} className="mt-3 mb-4" />
          )}
          <div className="flex flex-col-reverse sm:flex-row sm:child:flex-1 mt-[40px] gap-2.5">
            <Button back variant="outlined" className="w-full" to="/cards">
              <FormattedMessage id="go-back" />
            </Button>
            <Button disabled={isSubmitDisabled} type="submit">
              <FormattedMessage id="next" />
            </Button>
          </div>
        </form>
      </FormProvider>
    </div>
  )
}
